<template lang="html">
  <div class="profile-wrapper-background">
    <div class="profile-wrapper">
      <div class="profile-links" ref="profileLinks">
        <!-- 1-->
        <div
          @click="activeComponent = link.component"
          v-for="(link, index) in getLinks"
          :key="index"
          :class="{ active: link.component === activeComponent }"
          class="link-wrapper"
          :ref="'link' + index"
        >
          <div class="image-wrapper">
            <div class="img-helper">
              <img :src="link.src" alt="link image" />
              <notification-counter
                v-if="link.counter && allNotificationsCount"
                :counter="allNotificationsCount"
              />
            </div>
          </div>
          <span>{{ link.label }}</span>
        </div>
        <div v-if="userAdmin" class="link-wrapper admin">
          <router-link
            v-if="userAdmin"
            :to="{ name: 'Admin', params: { lang: $i18n.locale } }"
            >Admin</router-link
          >
        </div>
      </div>
      <div class="content swing-in-top-fwd">
        <!--2 -->
        <keep-alive>
          <component
            class="swing-in-top-fwd"
            v-bind:is="activeComponent"
          ></component>
        </keep-alive>
      </div>
    </div>
  </div>
</template>

<script>
import Profile from '@/components/profile/profile.vue'
import MyPurchases from '@/components/profile/myPurchases.vue'
import MySales from '@/components/profile/mySales.vue'
import NotificationsWrapper from '@/components/profile/notificationsWrapper.vue'
import Sugestions from '@/components/profile/sugestions.vue'
import MyBuyers from '@/components/profile/myBuyers.vue'
import MySellers from '@/components/profile/mySellers.vue'
import NotificationCounter from '@/components/notificationCounter.vue'
import { mapState } from 'vuex'
export default {
  name: 'Profile',
  components: {
    Profile,
    MyPurchases,
    MySales,
    NotificationsWrapper,
    Sugestions,
    MyBuyers,
    MySellers,
    NotificationCounter
  },
  data () {
    return {
      activeComponent: MySales,
      windowWidth: window.innerWidth
    }
  },
  mounted () {
    window.addEventListener('resize', this.onResize)
  },

  computed: {
    ...mapState(['allNotificationsCount', 'userAdmin']),
    getLinks () {
      return [
        {
          label: this.$t('profile.links.profile'),
          src: require('@/assets/icons/profile.png'),
          component: Profile
        },
        {
          label: this.$t('profile.links.myPurchases'),
          src: require('@/assets/icons/myPurchases.png'),
          component: MyPurchases
        },
        {
          label: this.$t('profile.links.mySales'),
          src: require('@/assets/icons/mySales.png'),
          component: MySales
        },
        {
          label: this.$t('profile.links.notifications'),
          src: require('@/assets/icons/notifications.png'),
          component: NotificationsWrapper,
          counter: true
        },
        {
          label: this.$t('profile.links.sugestions'),
          src: require('@/assets/icons/sugestions.png'),
          component: Sugestions
        },
        {
          label: this.$t('profile.links.myBuyers'),
          src: require('@/assets/icons/myBuyers.png'),
          component: MyBuyers
        },
        {
          label: this.$t('profile.links.mySellers'),
          src: require('@/assets/icons/mySellers.png'),
          component: MySellers
        }
      ]
    }
  },
  methods: {
    onResize () {
      this.windowWidth = window.innerWidth
    }
  },
  destroyed () {
    window.removeEventListener('resize', this.onResize)
  }
}
</script>

<style lang="scss" scoped>
.profile-wrapper-background {
  background: #f2f2f2;
  padding-top: 30px;
  padding-bottom: 60px;
  width: 100%;

  .profile-wrapper {
    display: flex;
    height: 100%;
    max-width: 1600px;
    width: calc(100% - 40px);
    margin: 0 auto;
    display: flex;
    background: white;
    padding: 40px 40px;
    box-sizing: border-box;
    .profile-links {
      width: 260px;
      min-width: 260px;
      border-right: 1px solid #eaeaea;
      // overflow-x: scroll;
      scroll-behavior: smooth;
      @import '@/assets/scss/scrollbarStyles.scss';
      @include scrollbar;

      .link-wrapper {
        display: flex;
        margin-bottom: 40px;
        cursor: pointer;
        transition: 0.3s;
        align-items: center;
        justify-content: left;

        span {
          font-weight: bold;
          font-size: 16px;
          line-height: 26px;
          letter-spacing: 0.06em;
          text-transform: uppercase;
        }
        .image-wrapper {
          .img-helper {
            position: relative;
            img {
              filter: grayscale(1);
            }
          }
          width: 30px;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          padding-bottom: 2px;
        }
      }
      .link-wrapper.active {
        img {
          filter: grayscale(0) !important;
        }
        color: $main-color;
      }
      .link-wrapper:last-child {
        margin-bottom: 0px;
      }
      .link-wrapper.admin a {
        font-weight: bold;
        font-size: 16px;
        line-height: 26px;
        letter-spacing: 0.06em;
        text-transform: uppercase;
        color: #8e3e4c;
        text-decoration: none !important;
      }
    }
    .content {
      flex-grow: 1;
      overflow-y: auto;
      @import '@/assets/scss/scrollbarStyles.scss';
      @include scrollbar;
      padding-right: 5px;
    }
  }
}

@media only screen and (max-width: 1000px) {
  .profile-wrapper {
    display: flex;
    flex-direction: column;
    width: 100% !important;
    padding: 40px 20px !important;

    .profile-links {
      margin: 0 auto;
      margin-bottom: 40px;
      display: flex;
      width: 100% !important;
      overflow: auto;
      min-width: 0px !important;
      border-right: 0px hidden !important;
      // border-bottom: 1px solid #EAEAEA;
      // display: -webkit-box;

      .link-wrapper {
        display: block;
        margin-bottom: 20px !important;
        cursor: pointer;
        transition: 0.3s;
        justify-content: center;
        span {
          font-weight: bold;
          font-size: 12px !important;
          line-height: 26px;
          letter-spacing: 0.06em;
          text-transform: uppercase;
          white-space: nowrap;
          padding: 0 20px;
        }
        .image-wrapper {
          .img-helper {
            position: relative;
            img {
              filter: grayscale(1);
            }
            display: none;
          }
          width: 0 !important;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          padding-bottom: 2px;
        }
      }
      .link-wrapper.active {
        border-bottom: 1px solid;
      }
    }

    .content {
      width: 100%;
      padding-right: 0px;
      margin: 0 auto;
      overflow-y: auto;
      @import '@/assets/scss/scrollbarStyles.scss';
      @include scrollbar;
      box-sizing: border-box;
      padding-right: 5px;

      .profile-my-sales-wrapper,
      .profile-my-purchases-wrapper {
        padding-left: 0px;
        width: 100%;
        margin: 0 auto;
      }
    }
  }
}
@media only screen and (max-width: 400px) {
  .profile-links {
    // width: 110px !important;
    // overflow: scroll;
    scroll-behavior: smooth;
  }
}
.swing-in-top-fwd {
  -webkit-animation: swing-in-top-fwd 0.5s
    cubic-bezier(0.175, 0.885, 0.32, 1.275);
  animation: swing-in-top-fwd 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}
@-webkit-keyframes swing-in-top-fwd {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@keyframes swing-in-top-fwd {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
</style>
